<template>
    <div>
        <x-header :left-options="{backText: ''}" >KOL 熱購</x-header>
        <p>check receipt message</p>
        <p>yes go to redemption page</p>
        <p>no go to fill in page</p>
    </div>

</template>

<script>
import {XHeader} from 'vux'
export default {
    name: 'Redemption',
    components: {
        XHeader
    }
}
</script>




// WEBPACK FOOTER //
// src/Account/containers/Credit/Redemption.vue